import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaintbrush32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPaintbrush32"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Paintbrush32)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m26.132 8.197-2.829 2.828-2.828-2.828 2.828-2.829a2 2 0 0 1 2.829 2.829m0 5.657-1.415-1.415 2.829-2.828a4 4 0 1 0-5.657-5.657l-2.828 2.828-1.415-1.414a4 4 0 0 0-5.656 0L9.868 7.49a2 2 0 0 0-.513 1.95 2 2 0 0 0-.194.17l-5.657 5.658a2 2 0 0 0 0 2.828l4.944 4.944.006.006.006.006 2.815 2.814.007.008.008.008 2.114 2.114a2 2 0 0 0 2.828 0l5.657-5.657q.093-.093.17-.194a2 2 0 0 0 1.951-.513l2.122-2.122a4 4 0 0 0 0-5.657M13.404 25.167l1.414 1.414 5.657-5.656-9.9-9.9-5.656 5.657 1.414 1.414 2.474-2.475a1 1 0 0 1 1.415 1.414L7.747 19.51l1.414 1.415 1.06-1.061a1 1 0 0 1 1.415 1.414l-1.06 1.06 1.413 1.415 3.182-3.182a1 1 0 0 1 1.415 1.414zm4.242-16.97-1.414-1.415a2 2 0 0 0-2.828 0l-2.121 2.122 11.313 11.314 2.122-2.122a2 2 0 0 0 0-2.828l-1.415-1.415-1.414-1.414-2.828-2.828z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Paintbrush32">
                        <path fill="#fff" d="M0 0h32v32H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPaintbrush32);
